<template>
  <div class="device-management overview">
    <div class="dashboard-container transaction-history">
      <div class="transaction-info">
        <div class="manage-devices d-flex flex-column left flex-sm-row align-items-center justify-content-between">
          <h2>Connected Clients</h2>
        </div>

        <div class="right">
          <p>Online</p>
          <div class="amount transaction-num">{{ online }}</div>
        </div>
      </div>

      <div class="profile">
        <div class="change-password box-style my-3 d-block">
          <h3 class="title">Filters</h3>
          <div class="change-password-content">
            <form class="change-password-form" @submit.prevent="filter">
              <div class="row align-items-start">
                <div class="col-md-6 col-xl-3">
                  <div class="form-group new-password">
                    <input type="text" @keyup.enter="filter"
                           v-model="form.countries" id="country" class="input-password form-control"
                           placeholder="Country" />
                  </div>
                  <validation-provider name="countries" v-slot="{ errors }">
                    <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-md-6 col-xl-3">
                  <div class="form-group new-password">
                    <input type="text" @keyup.enter="filter"
                           v-model="form.versions" id="version" class="input-password form-control"
                           placeholder="App Version" />
                  </div>
                  <validation-provider name="versions" v-slot="{ errors }">
                    <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-md-6 col-xl-3">
                  <div class="form-group d-flex justify-content-start">
                    <button class="main-btn save_password"
                            type="submit"
                            @click="filter"
                            :disabled="$wait.is('clients_fetch')">Filter</button>
                  </div>
                </div>
              </div>
            </form>
            <div class="row mt-3">
              <h3>Countries:</h3>
              <ul class="list-inline">
                <li class="list-inline-item"><a href="#" @click="filterByCountry('')">ALL</a>: <span v-if="form.countries === ''">{{ online }}</span></li>
                <li class="list-inline-item" v-for="[country, nodes] in stats.countries" :key="country">
                  <a href="#" @click="filterByCountry(country)" class="text-uppercase">{{ country }}</a>: {{ nodes }}
                </li>
              </ul>
            </div>
            <div class="row mt-3">
              <h3>Pools:</h3>
              <ul class="list-inline">
                <li class="list-inline-item" v-for="[pool, nodes] in stats.pools" :key="pool">
                  <span class="text-lowercase">{{ pool }}</span>: {{ nodes }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="devices box-style">
        <div class="device" v-for="d in clients" :key="d.id">
          <div class="device-name">
            <div class="icon" v-html="iconOS(d.os)">
            </div>
            <p><a :href="userLink(d.user_id)">{{ d.country }} {{ d.region }} {{ d.city }}</a></p>
          </div>
          <div class="device-active">
            <p>{{ d.app_version }}</p>
          </div>
          <div class="device-type">{{ formatOS(d.os) }} {{ d.version }}</div>
          <div class="device-type">{{ d.ipv4 }}</div>
        </div>
        <div class="text-center" v-if="clients.length === 0"><h2>No clients</h2></div>
      </div>

      <div class="devices box-style mt-5" v-if="pages > 1">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" v-for="page in pages" :key="page" :class="page === pagination.current ? 'active' : ''">
              <a class="page-link" @click="loadPage(page)">{{ page }}</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import {Client} from "@/models"
import {iconOS, formatOS} from "@/helpers"

import API from "@/api"
const api = new API()
import Vue from 'vue'

export default {
  name: "Online",
  data() {
    return {
      form: {
        countries: '',
        versions: ''
      },
      stats: {
        countries: null,
        pools: null
      },
      online: 0,
      pagination: {
        limit: 50,
        offset: 0,
        current: 1
      }
    }
  },
  computed: {
    clients() {
      return Client.query().orderBy('online', 'desc').get()
    },
    pages() {
      return Math.ceil(this.online / this.pagination.limit)
    }
  },
  mounted() {
    this.$wait.start('country_stats')
    api.getClientsCountryStats().then(r => {
      if (!r.data.results || r.data.results.length === 0) {
        return
      }

      this.stats.countries = Object.keys(r.data.results).map((key) => [key, r.data.results[key]]).sort((a, b) => b[1] - a[1])
    }).finally(() => this.$wait.end('country_stats'))

    this.$wait.start('pool_stats')
    api.getClientsPoolStats().then(r => {
      if (!r.data.results || r.data.results.length === 0) {
        return
      }

      this.stats.pools = Object.keys(r.data.results).map((key) => [key, r.data.results[key]]).sort((a, b) => b[1] - a[1])
    }).finally(() => this.$wait.end('pool_stats'))

    this.loadPage(1)
  },
  methods: {
    loadPage(n) {
      this.pagination.current = n
      this.pagination.offset = (n-1) * this.pagination.limit

      this.$wait.start('clients_fetch')
      const countries = this.form.countries.length === 0 ? [] : this.form.countries.split(',')
      const data = {countries: countries, limit: this.pagination.limit, offset: this.pagination.offset}
      api.getClients(data)
          .then(r => {
            this.online = r.data.count
            Client.deleteAll().then(() => Client.insertOrUpdate({
              data: r.data.results
            }))
          })
          .catch(e => console.log(e))
          .finally(() => this.$wait.end('clients_fetch'))
    },
    filterByCountry(name) {
      this.form.countries = name.toLowerCase()
      this.form.versions = ''
      this.filter()
    },
    filter() {
      this.pagination.offset = 0
      this.pagination.current = 0

      this.$wait.start('clients_fetch')
      const countries = this.form.countries.length === 0 ? [] : this.form.countries.split(',')
      const versions = this.form.versions.length === 0 ? [] : this.form.versions.split(',')
      const data = {
        countries: countries,
        versions: versions,
        limit: this.pagination.limit,
        offset: this.pagination.offset
      }

      api.getClients(data)
        .then(r => {
          this.online = r.data.count
          Client.deleteAll().then(() => Client.insertOrUpdate({
            data: r.data.results
          }))
        })
        .catch(e => console.log(e))
        .finally(() => this.$wait.end('clients_fetch'))
    },
    userLink(userId) {
      return `${Vue.httpProtocol}://${Vue.host}/admin/api/user/${userId}/change/`
    },
    iconOS(name) {
      return iconOS(name)
    },
    formatOS(name) {
      return formatOS(name)
    }
  }
}
</script>


<style scoped>
.page-link {
  font-size: 14px !important;
  cursor: pointer;
}
</style>
